import React, {useState} from 'react';
import {Col, Row} from 'react-bootstrap';
import {getUserRoleName, taskStatusEnum} from '../../../../../utils/constants';
import {assets} from '../../../../../utils/assetsSrc';
import './device-card.scss';
import Confirmation from '../../../../../components/confirmation/confirmation';
import {useSelector} from 'react-redux';
import {getLoginStateSelector} from '../../../../../redux/selectors/loginSelector';
import {RiskChip, SeverityBadge} from '../../../../../components/risk-chip/riskChip';
import {
  FEASIBILITY_STOP,
  IMPACT_STOP,
} from '../../../../../utils/cybersecurityScoring';

const statusClass = {
  1: 'device-status--progress',
  2: 'device-status--completed',
  3: 'device-status--notstarted',
  4: 'device-status--needsreview',
};

export default function DeviceCard({data, handleDeviceSelection, handleDeviceDelete}) {
  const [deleteConfirm, setDeleteConfirm] = useState(false);
  const {loggedInUser} = useSelector(getLoginStateSelector());
  const readOnly = getUserRoleName(loggedInUser?.role) === 'general';
  const derived = data?.derived;

  const contactFields = [
    {label: 'Contact center', value: data?.contact_centre},
    {label: 'Contact', value: data?.contact},
  ].filter(field => typeof field.value === 'string' && field.value.trim());

  return (
    <>
      <div onClick={handleDeviceSelection} className="device-card-wrapper">
        <Row className="device-card__header">
          <Col xs={8}>
            <span className="device-name">{data?.name}</span>
          </Col>
          <Col xs={4} className="device-card__risk">
            <span className={`device-status ${statusClass[data?.task_status] ?? ''}`}>
              {taskStatusEnum.find(item => item.id === data?.task_status)?.name}
            </span>
            <RiskChip value={derived?.risk_value} level={derived?.risk_level} />
          </Col>
        </Row>
        <div className="device-card__divider" />
        <div className="device-card__attributes">
          <div className="device-card__fields">
            <div className="device-card__field">
              <div className="sub-heading">Most severe impact</div>
              <span className="device-card__field-value">
                <SeverityBadge
                  label={derived?.most_severe_impact_label}
                  stop={IMPACT_STOP[derived?.most_severe_impact]}
                />
              </span>
            </div>
            <div className="device-card__field">
              <div className="sub-heading">Attack feasibility</div>
              <span className="device-card__field-value device-card__field-value--feasibility">
                {derived?.feasibility_total !== null &&
                  derived?.feasibility_total !== undefined && (
                    <span className="device-card__feasibility-number">
                      {derived.feasibility_total}
                    </span>
                  )}
                <SeverityBadge
                  label={derived?.feasibility_rating}
                  stop={FEASIBILITY_STOP[derived?.feasibility_rating]}
                />
              </span>
            </div>
            {contactFields.map(field => (
              <div className="device-card__field" key={field.label}>
                <div className="sub-heading">{field.label}</div>
                <span className="device-card__field-value">{field.value}</span>
              </div>
            ))}
          </div>
          {!readOnly && (
            <div className="device-card__actions">
              <span
                className="device-card__action device-card__action--disabled"
                onClick={e => e.stopPropagation()}>
                <img src={assets.copyIcon} />
                <span>Duplicate</span>
              </span>
              <span
                className="device-card__action"
                onClick={e => {
                  setDeleteConfirm(true);
                  e.stopPropagation();
                }}>
                <img src={assets.trash} />
                <span>Delete</span>
              </span>
            </div>
          )}
        </div>
      </div>
      <Confirmation
        label={'Delete Device'}
        show={deleteConfirm}
        setShow={setDeleteConfirm}
        confirmationType="typeDelete"
        secondaryButtonClickHandler={() => setDeleteConfirm(false)}
        primaryButtonClickHandler={() => {
          handleDeviceDelete();
          setDeleteConfirm(false);
        }}
      />
    </>
  );
}
